import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'countDaysDiff',
})
export class CountDaysDiffPipe implements PipeTransform {
    transform(item: any): number {
        return countDaysDiff(item);
    }
}

export function countDaysDiff(item: { to: string, packageTo: string }): number {
    if (!item || !item.to || !item.packageTo) {
        return 0;
    }

    const now = new Date().getTime();
    const toDate = new Date(item.to).getTime();
    const packageToDate = new Date(item.packageTo).getTime();
    let diff = packageToDate - Math.min(now, toDate);

    if (now > toDate) {
        // subtract one day
        diff -= 1000 * 3600 * 24;
    }

    return Math.ceil(diff / (1000 * 3600 * 24));
}
